<template>
  <div class="con">
    <Nav />
    <img src="../assets/img/banner1-home.jpg" alt="" class="banner">
    <!-- <img src="../assets/img/20211021-200152.jpg" alt="" class="banner"> -->
    <div class="wenan">
      <div class="banner-t2">{{ $t("home.bannerT2") }}&nbsp;&nbsp;&nbsp;{{ $t("home.bannerT22") }}</div>
      <div class="banner-text">{{ $t("home.bannerText") }}</div>
      <div class="banner-text2">{{ $t("home.bannerText2") }}</div>
      <div class="banner-bth cup" @click="checkNav('/about')">{{ $t("home.bannerBth") }}</div>
    </div>
    <div class="w">
      <div class="to">
        <div class="to-in mr40">
          <h4>{{ $t("home.context") }} &nbsp;/</h4>
          <div class="hz" @click="checkNav('/about')">
            <div class="motia">
              <span class="motia-one">{{ $t("home.context4") }}
                <i class="iconfont iconLine23"></i>
              </span>
            </div>
            <img src="../assets/img/gy.png" alt="" class="banner2">
          </div>
        </div>
        <div class="to-in ml66">
          <h4>{{ $t("home.context2") }} &nbsp;/</h4>
          <!-- <div class="hz" @click="checkNav('/join')"> -->
          <div class="hz">
            <div class="motia">
              <a v-bind:href="joinUsSocialLink" target="_blank" class="motia-two">
                {{ $t("home.context2_1") }}<i class="iconfont iconLine23"></i>
              </a>
              <a v-bind:href="joinUsCampusLink" target="_blank" class="motia-two">
                {{ $t("home.context2_2") }}<i class="iconfont iconLine23"></i>
              </a>
            </div>
            <img src="../assets/img/jr.png" alt="" class="banner2">
          </div>
        </div>
        <div class="to-in ml66">
          <h4>{{ $t("home.context3") }} &nbsp;/</h4>
          <div class="hz" @click="checkNav('/contact')">
            <div class="motia">
              <span class="motia-one">{{ $t("home.context4") }}<i class="iconfont iconLine23"></i></span>
            </div>
            <img src="../assets/img/lx.png" alt="" class="banner2">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from './nav'
import Bus from '../assets/js/bus'
export default {
  name: 'IndexContent',
  components: {
    Nav,
  },
  methods: {
    checkNav(url) {
      if (this.$route.path != url) {
        Bus.$emit("nav", url);
        this.$router.push(url)
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.pageYOffset = 0
      }
    }
  },
  data() {
    return {
      joinUsSocialLink: process.env.VUE_APP_MOKA_SOCIAL_LINK || '/join',
      joinUsCampusLink: process.env.VUE_APP_MOKA_CAMPUS_LINK || '/join'
    }
  }
}
</script>

<style scoped lang="less">
.con {
  width: 100%;
  height: 100%;
  background: #F8F8F8;
  min-width: 1260px;
  position: relative;

  .banner {
    width: 100%;
    min-width: 1260px;
    height: 630px;
    object-fit: cover;
  }

  .wenan {
    width: 1260px;
    height: 630px;
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 1;
    z-index: 2;
    margin-left: -630px;
    // margin: 0 auto;
    overflow: hidden;

    .banner-t1 {
      position: absolute;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      opacity: 0.3;
      width: 170px;
      left: 60px;
      top: 115px;
      line-height: 25px;
    }

    .banner-t2 {
      font-style: normal;
      font-weight: 500;
      font-size: 44px;
      color: #FFFFFF;
      margin-top: 125px;
      margin-left: 75px;
      position: relative;
      padding-bottom: 50px;
    }

    .banner-t2::before {
      width: 30px;
      height: 2px;
      border-radius: 14px;
      position: absolute;
      background: #fff;
      left: 0;
      bottom: 0;
      content: "";
    }

    .banner-text {
      width: 800px;
      font-size: 26px;
      line-height: 40px;
      letter-spacing: 0.14em;
      color: #FFFFFF;
      margin-left: 75px;
      margin-top: 40px;
    }

    .banner-text2 {
      width: 800px;
      font-size: 26px;
      line-height: 40px;
      letter-spacing: 0.14em;
      color: #FFFFFF;
      margin-left: 75px;
      // margin-top: 40px;
    }

    .banner-bth {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #2284F6;
      border-radius: 2px;
      color: #fff;
      margin-left: 75px;
      margin-top: 67px;
      font-size: 14px;
    }

    .banner-bth:hover {
      background: #2FA8FF;
    }
  }

  .w {
    width: 100%;
    background: #fff;

    .to {
      width: 1200px;
      background: #fff;
      margin: 0 auto;
      padding-bottom: 80px;
      overflow: hidden;

      .to-in {
        width: 356px;
        float: left;
        overflow: hidden;

        h4 {
          font-weight: 500;
          font-size: 20px;
          color: #242A32;
          margin-top: 80px;
          margin-bottom: 20px;
        }

        .hz {
          width: 356px;
          height: 200px;
          overflow: hidden;
          position: relative;

          .banner2 {
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            width: 356px;
            height: 200px;
            cursor: pointer;
          }

          .motia {
            position: absolute;
            z-index: 2;
            top: 0;
            left: 0;
            width: 356px;
            height: 200px;
            background: rgba(13, 28, 66, 0);
            text-align: center;

            span,
            a {
              display: block;
              // width: 120px;
              height: 38px;
              border: 1px solid #FFFFFF;
              -webkit-transform: translate(-50%, -50%);
              -moz-transform: translate(-50%, -50%);
              transform: translate(-50%, -50%);
              box-sizing: border-box;
              padding-left: 20px;
              padding-right: 15px;
              // margin: 81px 20px;
              font-size: 14px;
              line-height: 37px;
              color: #FFFFFF;
              opacity: 0;
              cursor: pointer;

              i {
                line-height: 38px;
                font-size: 12px;
                color: #fff;
                margin-left: 2px;
              }
            }

            span:hover,
            a:hover {
              background: #fff;
              color: #242A32;
              text-decoration: none;

              i {
                color: #242A32;
              }
            }

            .motia-one {
              position: absolute;
              top: 50%;
              left: 50%;
            }

            .motia-two {
              position: absolute;
              top: 50%;
            }
            .motia-two:first-of-type {
              left: 30%;
            }
            .motia-two:last-of-type {
              right: -6%;
            }
          }
        }

        .hz:hover {
          .banner2 {
            animation: myfirst .6s linear;
            -moz-animation: myfirst .6s linear;
            /* Firefox */
            -webkit-animation: myfirst .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }

          .motia {
            animation: myfirst2 .6s linear;
            -moz-animation: myfirst2 .6s linear;
            /* Firefox */
            -webkit-animation: myfirst2 .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst2 .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }

          .Line {
            animation: myfirst3 .6s linear;
            -moz-animation: myfirst3 .6s linear;
            /* Firefox */
            -webkit-animation: myfirst3 .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst3 .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }

          span,
          a {
            animation: myfirst3 .6s linear;
            -moz-animation: myfirst3 .6s linear;
            /* Firefox */
            -webkit-animation: myfirst3 .6s linear;
            /* Safari 和 Chrome */
            -o-animation: myfirst3 .6s linear;
            /* Opera */
            animation-fill-mode: forwards;
          }
        }

        @keyframes myfirst {
          to {
            width: 427px;
            height: 240px;
          }
        }

        @-webkit-keyframes myfirst

        /* Safari 和 Chrome */
          {
          to {
            width: 427px;
            height: 240px;
          }
        }

        @keyframes myfirst2 {
          to {
            background: rgba(13, 28, 66, 0.6);
          }
        }

        @-webkit-keyframes myfirst2

        /* Safari 和 Chrome */
          {
          to {
            background: rgba(13, 28, 66, 0.6);
          }
        }

        @keyframes myfirst3 {
          to {
            opacity: 1;
          }
        }

        @-webkit-keyframes myfirst3

        /* Safari 和 Chrome */
          {
          to {
            opacity: 1;
          }
        }
      }
    }
  }
}

.ml66 {
  margin-left: 66px;
}
</style>


// WEBPACK FOOTER //
// src/views/indexContent.vue